module.exports = __webpack_public_path__ + "static/media/qr-code-vk.1c2f0974.svg";